export enum COMMISSION_LEVEL {
  "AUH" = '57',
  "AUH101" = '57',
  "AUH111" = '57',

  "AUM" = '56',
  "AUM101" = '5657',
  "AUM111" = '5657',

  "HBA" = '55',
  "HBA101" = '5557',
  "HBA111" = '555657',

  "AIA" = '51',
  "BROKER" = '52',
  "EMPLOYEE" = '60'
};
